import React from 'react';

const Placeholder = ({children, size}) => (
  children ||
  <div className="placeholder" style={{width: (size || 2) + 'em'}}>&nbsp;</div>
);

export default Placeholder;
